/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import Header from './headerPhase2';
import { Helmet } from 'react-helmet';
import { Carousel } from 'antd';
import redoBtn from './../assets/img/redo-btn.svg';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../state';
import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { resources } from '../resource';

import { formatErrorMessage } from '../utils/errorHandler';
import { logError } from '../utils/logger';
import axios from 'axios';
import ErrorModal from './organisms/ErrorModal';

function AssignmentOfBenefit(props) {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const dispatch = useDispatch();
  let signatureRef = React.useRef(null);
  const actions = bindActionCreators(actionCreators, dispatch);
  const [updatePatientSpinner, setUpdatePatientSpinner] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState(false);
  const [canvasEmpty, setCanvasEmpty] = useState(true);
  const [benefitTypes, setBenefitTypes] = useState('');
  const [hasSignature, setHasSignature] = useState(false);

  const navigate = useNavigate();
  let canvasRef;
  const sessionId = useSelector((store) => store.auth.sessionId)
  const _resourcesENG = resources['en'];
  const _resourcesSPA = resources['spa'];
  const _resourcesCr = resources['cr'];
  const _resources = resources[props.language];

  const initialFormData = Object.freeze({
    AnythingChangeInHealthYourLastAppointment: null,
    InsuranceChangeSinceLastAppointment: null,
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
  });

  const patientForm = useSelector((state) => state.patientForm);
  const formTranslations = useSelector((state) => state.formTranslations.translations);
  const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;

  useEffect(() => {
    if (patientForm?.patientForm?.companyId !== '' && patientForm?.patientForm?.companyId != null) {
      getPatientBenefits();
    }
  }, [patientForm?.patientForm]);

  useEffect(() => {
    const fetchTermsData = async () => {
      try {
        const response = await axios.get(`${API_URL}Settings/GetFormContentTerms`);
        actions.setTranslations(response.data.formTranslationContents)
      } catch (err) {
        console.error(err);
      }
    };
    if(formTranslations.length == 0){
      fetchTermsData();
    }
  }, []);

  const vob = formTranslations?.find((item) => item.fcname == "VERIFICATION_OF_BENEFITS");
  const vobEng = vob?.fcenglish
  const vobSpa = vob?.fcspanish
  const vobCr = vob?.fccreole

  // function to replace placeholders in the text
  const replacePlaceholders = (text, variables) => {
    if (text) {
      return text.replace(/\[PLACEHOLDER_(\d+)\]/g, (match, placeholderNumber) => {
        
        const key = `PLACEHOLDER_${placeholderNumber}`;
        if (variables[key] !== undefined) {
          // if placeholderNumber is 3 or 5
          if (placeholderNumber === '3' || placeholderNumber === '5') {
            return `<b>${variables[key]}%</b>`;
          } else {
            return `<b>$${variables[key]}</b>`;
          }
        } else {
          return match;
        }
      });
    }
};

  const variables = { 
    PLACEHOLDER_1: benefitTypes?.deductible ?? "",
    PLACEHOLDER_2: benefitTypes?.deductibleUsed ?? "",
    PLACEHOLDER_3: benefitTypes?.coinsurance ?? "",
    PLACEHOLDER_4: benefitTypes?.coPay ?? "",
    PLACEHOLDER_5: benefitTypes?.coinsurance ?? "",
  };

  const vobEngText = replacePlaceholders(vobEng, variables);
  const vobSpaText = replacePlaceholders(vobSpa, variables);
  const vobCrText = replacePlaceholders(vobCr, variables);

  var url, clinicId;
  if (patientForm.clinicName.includes('/patient-checkin/checkin?clinicId=')) {
    if (patientForm.clinicName !== '') {
      url = new URL(patientForm.clinicName);
      clinicId = url.searchParams.get('clinicId');
    }
  } else {
    clinicId = patientForm.clinicName;
  }

  const getPatientBenefits = async () => {
    try {

      const url = new URL(window.location.href);
      let epno = url.searchParams.get('Epno') || '' + patientForm.validationResponse.epno;
      let cId = url.searchParams.get('CompanyId') || patientForm.patientForm.companyId;
  
      const requestData = {
        companyId: cId,
        epno: epno,
      };
  
      const source = axios.CancelToken.source();
  
      const response = await axios.post(
        `${API_URL}PatientCheckIn/GetBenefitInformation`,
        requestData,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          timeout: process.env.REACT_APP_API_TIMEOUT,
          cancelToken: source.token,
        }
      );
  
      const benefitTypes = response.data;
      setBenefitTypes(benefitTypes?.benefitInformation);
  
      await logError({
        source: "assignmentOfBenefit.getPatientBenefits",
        message: "Success GetBenefitInformation API Call",
        exception: null,
        sessionID: sessionId,
      });
  
    } catch (error) {
      logActivity(error, `assignmentOfBenefit.getPatientBenefits`, "Error in GetBenefitInformation API Call")
      setApiErrorMessage(true);
    }
  };

  const logActivity = async (error, source, message) => {
    const errorMessage = formatErrorMessage(error);
    await logError({
      source: source,
      message: message,
      exception: errorMessage,
      sessionID: sessionId,
    });
  };

  const handleClick = async () => {
    try {
      const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;

      setUpdatePatientSpinner(true);
      url = new URL(window.location.href);
      let epno = url.searchParams.get('Epno');
      let companyId = url.searchParams.get('CompanyId');
      let checkIn = false;

      // default values if epno or companyId are not found in URL
      if (epno === null || companyId === null) {
        epno = '' + patientForm.validationResponse.epno;
        companyId = patientForm.patientForm.companyId;
        checkIn = true;
      }

      // prepare the deductible values and ensure they are numbers (default to 0 if empty string)
      const deductible = benefitTypes && benefitTypes.deductible !== '' ? benefitTypes.deductible : 0;
      const deductibleUsed = benefitTypes && benefitTypes.deductibleUsed !== '' ? benefitTypes.deductibleUsed : 0;
      const coinsurance = benefitTypes && benefitTypes.coinsurance !== '' ? benefitTypes.coinsurance : 0;
      const coPay = benefitTypes && benefitTypes.coPay !== '' ? benefitTypes.coPay : 0;

      const dataSet = canvasRef.toDataURL();
      
      const body = {
        epno,
        companyId,
        deductible,
        deductibleUsed,
        coinsurance,
        coPay,
        signature: dataSet,
        signatureExtension: 'jpeg',
      };

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), process.env.REACT_APP_API_TIMEOUT);

      const response = await axios.post(
        `${API_URL}PatientCheckIn/SubmitAssignmentofbenefits`,
        body,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          signal: controller.signal,
        }
      );

      clearTimeout(timeoutId);

      if (response.data.responseCode === 200) {
        await logError({
          source: "assignmentOfBenefit.handleClick",
          message: "Success Assignemnt of benefits API call",
          exception: null,
          sessionID: sessionId,
        });

        if (checkIn) {
          if (
            Array.isArray(patientForm.validationResponse) &&
            patientForm.validationResponse.length === 0
          ) {
            navigate(`/patient-checkin/ai-scribing-consent`, {
              state: { fromFlow: true, fromReview: true },
            });
          } else if (
            typeof patientForm.validationResponse === "object" &&
            patientForm.validationResponse !== null &&
            patientForm.validationResponse.isAIConsentRequired
          ) {
            navigate(`/patient-checkin/ai-scribing-consent`, {
              state: { fromFlow: true, fromReview: true },
            });
          } else {
            navigate(`/patient-checkin/signature`, { state: { fromFlow: true } });
          }
          
        } else {
          actions.clearPhase2Form([]);
          navigate('/patient-checkin/form-submitted', {
            state: {
              response: response.data.message,
              newPatient: false,
            },
          });
        }
      } else {
        setUpdatePatientSpinner(false);
        logActivity("Response is not 200", `assignmentOfBenefit.handleClick`, "Error in Assignemnt of benefits API call")
        setApiErrorMessage(true);
      }

    } catch (error) {
      logActivity(error, `assignmentOfBenefit.handleClick`, "Error in AAssignemnt of benefits API call")
      setUpdatePatientSpinner(false);
      setApiErrorMessage(true);
    }
  };

  const redoButtonClear = () => {
    canvasRef.clear();
    setHasSignature(false);
    setCanvasEmpty(true);
  };

  const renderCarousel = () => (
    <Carousel>
      {["clinic-pic-one", "clinic-pic-two", "clinic-pic-three", "clinic-pic-four"].map(
        (pic, index) => (
          <div key={index}>
            <div className={pic}></div>
          </div>
        ),
      )}
    </Carousel>
  );

  canvasRef = patientForm.signature;
  
  return (
    <>
      <ErrorModal
        visible={apiErrorMessage}
        onClose={() => setApiErrorMessage(false)}
        errorMessage={_resources.Checkin.ERROR}
      />
      <Header />
      <Helmet>
        <title>Cora Health | Appointment Submitted</title>
      </Helmet>

      <div className="confirm-and-book-appointment checkin-page-carousel d-flex justify-content-between">
        <div className="col-lg-7 signature-data">
          <div className="signature-heading">
            <p className="signature">
              {_resources.VerificationOfBenefits.HEADING}
            </p>
          </div>
          {/* <div className="signature-canvas"> */}
          <p className="pop-up-modal-text-small benefit-assig-notif" dangerouslySetInnerHTML={{__html: vobEngText}}>
          </p>
          <p className="pop-up-modal-text-small benefit-assig-notif" dangerouslySetInnerHTML={{__html: vobSpaText}}>
          </p>
          <p className="pop-up-modal-text-small benefit-assig-notif" dangerouslySetInnerHTML={{__html: vobCrText}}>
          </p>
          {/* </div> */}
          <div className="signature-canvas">
            <SignatureCanvas
              ref={(ref) => (canvasRef = ref)}
              onEnd={(e) => {
                if (e['composed']) {
                  setCanvasEmpty(false);
                }
              }}
              onBegin={() => {
                setHasSignature(true);
              }}
              va
              penColor="green"
              // canvasProps={{ width: 300, height: 350, className: "sigCanvas" }}
              canvasProps={{
                // width: 700,
                // height: 350,
                className: 'sigCanvas',
              }}
            />
            {!hasSignature && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                {_resources.VerificationOfBenefits.SIGN_HERE}
              </div>
            )}

            <Button className="redo" onClick={redoButtonClear}>
              <img src={redoBtn} alt="date" />
              <span className="ml-2">
                {_resources.VerificationOfBenefits.REDO}
              </span>
            </Button>
          </div>

          <div className="screen">
            <Button
              className="dual-book-button continue-btn"
              onClick={() => handleClick()}
              variant="contained"
              color="primary"
              type="submit"
              size="large"
              disabled={canvasEmpty ? true : false}
            >
              {updatePatientSpinner && (
                <Spin indicator={antIcon} className="mr-3 submit-btn-loader" />
              )}{' '}
              Submit
            </Button>
            <Button
              size="large"
              id="back-btn"
              onClick={() => window.history.back()}
              className="dual-book-button back-button"
              variant="contained"
            >
              Back
            </Button>
          </div>
        </div>
        <div className="col-lg-5 p-0 carousel-column">{renderCarousel()}</div>
      </div>
    </>
  );
}

export default AssignmentOfBenefit;
